import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Button, SECONDARY, SMALL } from '@glu/buttons-react';

import useLocale from 'components/useLocale/useLocale';
import { clearGrids } from 'logic/store/grids/actions';
import { logout, logoutAll } from 'logic/store/authentication/actions';
import capitalize from 'utils/capitalize';
import { STORAGE_KEYS, WORKSPACES } from 'constants.js';

import useStyles from './UserEmulationNotification.styles';

const pathname = WORKSPACES.DASHBOARD;

export function UserEmulationNotificationComponent({ logout, logoutAll, setPosition, user }) {
  const history = useHistory();
  const { userName, customerName = sessionStorage.getItem(STORAGE_KEYS.EMULATION_CUSTOMER_NAME) } =
    user;
  const locale = useLocale();
  const { buttons, content, info, root, strong } = useStyles();
  const rootRef = useRef(null);
  /**
   * Update position of the parent element
   * @returns {void}
   */
  const updatePosition = () => {
    const height = rootRef.current.offsetHeight;
    setPosition(height);
  };

  const onUnmount = () => window.removeEventListener('resize', updatePosition);

  const onMount = () => {
    updatePosition();
    window.addEventListener('resize', updatePosition);
    return onUnmount;
  };

  // Bind/Unbind events
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onMount, []);

  return (
    <div ref={rootRef} className={root}>
      <div className={content}>
        {/* Text */}
        <span className={info}>
          {locale['userEmulation.workflowFor']}{' '}
          <span className={strong}>
            {capitalize(customerName)} - {capitalize(userName)}
          </span>{' '}
          {locale['userEmulation.note']}
        </span>

        {/* Buttons */}
        <section className={buttons}>
          <Button
            className="btn btn-primary"
            size={SMALL}
            dataQa="new-emulation"
            onClick={() => {
              clearGrids();
              logout();
              history.push({
                pathname,
                state: {
                  excludePathname: pathname
                }
              });
            }}
          >
            {locale['userEmulation.new']}
          </Button>
          <Button
            className="btn"
            variant={SECONDARY}
            size={SMALL}
            onClick={() => {
              clearGrids();
              logoutAll();
              history.push({
                pathname,
                state: {
                  excludePathname: pathname
                }
              });
            }}
          >
            {locale['userEmulation.logout']}
          </Button>
        </section>
      </div>
    </div>
  );
}

UserEmulationNotificationComponent.propTypes = {
  user: PropTypes.shape({}).isRequired,
  clearGrids: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  logoutAll: PropTypes.func.isRequired,
  setPosition: PropTypes.func.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  user: state.auth?.user ?? null
});

const mapDispatchToProps = (dispatch) => ({
  logout: (...params) => dispatch(logout(...params)),
  logoutAll: (...params) => dispatch(logoutAll(...params)),
  clearGrids: () => clearGrids(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserEmulationNotificationComponent);
